module.exports = __webpack_public_path__ + "img/congrat-bg.0cdbd558.jpg";